import {TableType as StaffTableType} from "../../containers/staff/StaffAllColumns";
import {CurrencyShort} from "../renderAmount";
import {csvArray, csvBoolean, csvDate, csvSalutation} from "./TableColumnExports";

export const staffValues = (
    key: string,
    row: StaffTableType,
    index: number,
    currencyShort: CurrencyShort,
    notExportable: string,
    outputFormat?: "pdf" | "csv",
    // eslint-disable-next-line max-params
): string | number => {
    // console.log("row", row);

    switch (key) {
        case "rowIndex":
            return `${index + 1}`;
        case "name":
            return `${row.firstname} ${row.lastname}`;
        case "firstname":
            return `${row.firstname}`;
        case "lastname":
            return `${row.lastname}`;
        case "salutation":
            return row.salutation ? csvSalutation(row.salutation) : "";
        case "email":
            return `${row.email ?? ""}`;
        case "phoneNumber":
            return `${row.phoneNumber ?? ""}`;
        case "mobileNumber":
            return `${row.mobileNumber ?? ""}`;
        case "level":
            // 0 (Assistenz) wie bisher leer; negativ = Stufe verborgen (Sichtbarkeitsregel „Personal“, #709)
            return row.level && row.level > 0 ? `${row.level}` : "";
        case "assignedLocations":
            return csvArray(row.assignedLocations?.map((location) => location.name) ?? []);
        case "active":
            return csvBoolean(Boolean(row.active));
        case "showInWeb":
            return csvBoolean(Boolean(row.showInWeb));
        case "address":
            const addressParts = [
                row.street,
                row.houseNumber,
                row.postCode,
                row.city,
            ].filter((part) => part);
            return addressParts.join(", ");
        case "street":
            return `${row.street ?? ""}`;
        case "houseNumber":
            return `${row.houseNumber ?? ""}`;
        case "postCode":
            return `${row.postCode ?? ""}`;
        case "city":
            return `${row.city ?? ""}`;
        case "birthDate":
            return csvDate(row.birthDate);
        case "birthPlace":
            return `${row.birthPlace ?? ""}`;
        case "joinDate":
            return csvDate(row.joinDate);
        case "leaveDate":
            return csvDate(row.leaveDate);
        case "annotation":
            return `${row.annotation ?? ""}`;
        case "socialSecurityNumber":
            return `${row.socialSecurityNumber ?? ""}`;
        case "healthInsuranceFund":
            return `${row.healthInsuranceFund ?? ""}`;
        case "rate":
            return row.rate ? `${row.rate} ${currencyShort}` : "";
        case "accountHolder":
            return `${row.accountHolder ?? ""}`;
        case "iban":
            return `${row.iban ?? ""}`;
        case "bic":
            return `${row.bic ?? ""}`;
        case "bank":
            return `${row.bank ?? ""}`;
        case "activeCourseCount":
            return `${row.activeCourseCount ?? 0}`;
        default:
            return notExportable;
    }
};

